// @flow
import {
  GetManagerCompliance,
  GetManagerComplianceSuccess,
  GetManagerComplianceError,
} from "@modules/reporting/constants/actions";
import type { ManagerComplianceState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: ManagerComplianceState = {
  error: null,
  requestsInProgress: 0,
  reportData: {
    absenceMonitoringPercentage: [],
    alertsReviewed: [],
    reasonsForDeclinedReferrals: [],
    reasonsForRtwNonCompliance: [],
    referralsCompleted: [],
    referralsCompliancePercentage: [],
    referralsCompliant: [],
    reviewsCompliant: [],
    rtwCompliancePercentage: [],
    rtwCompliant: [],
    rtwSubmitted: [],
    totalCompliancePercentage: [],
  },
};

export const setLoading = (state: ManagerComplianceState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetManagerComplianceSuccess = (state: ManagerComplianceState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    reportData: payload,
  };
};
export const onGetManagerComplianceError = (state: ManagerComplianceState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export default (
  state: ManagerComplianceState = initialState,
  action: Object,
): ManagerComplianceState => {
  const act = {
    [GetManagerCompliance]: setLoading,
    [GetManagerComplianceSuccess]: onGetManagerComplianceSuccess,
    [GetManagerComplianceError]: onGetManagerComplianceError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
